import {GetMessagingConversationIdUserError} from '../Errors/GetMessagingConversationIdUserError.js'

export class GetMessagingConversationIdUserRequest {
  #entityType
  #entityId
  #buyerId
  #sellerId
  #isProfessionalSeller

  constructor({entityType, entityId, buyerId, sellerId, isProfessionalSeller}) {
    this.#entityType = entityType
    this.#entityId = entityId
    this.#buyerId = buyerId
    this.#sellerId = sellerId
    this.#isProfessionalSeller = isProfessionalSeller
  }

  static validate({entityId, buyerId, sellerId}) {
    if (!buyerId || typeof buyerId !== 'string') {
      throw GetMessagingConversationIdUserError.create({
        message: '[GetMessagingConversationIdUserRequest.validate] buyerId is required and must be a string'
      })
    }
    if (!sellerId || typeof sellerId !== 'string') {
      throw GetMessagingConversationIdUserError.create({
        message: '[GetMessagingConversationIdUserRequest.validate] sellerId is required and must be a string'
      })
    }
    if (!entityId || typeof entityId !== 'string') {
      throw GetMessagingConversationIdUserError.create({
        message: '[GetMessagingConversationIdUserRequest.validate] entityId is required and must be a string'
      })
    }
  }

  static create = ({entityType, entityId, buyerId, sellerId, isProfessionalSeller}) => {
    GetMessagingConversationIdUserRequest.validate({entityId, buyerId, sellerId})

    return new GetMessagingConversationIdUserRequest({
      entityType,
      entityId,
      buyerId,
      sellerId,
      isProfessionalSeller
    })
  }

  get buyerId() {
    return this.#buyerId
  }

  get sellerId() {
    return this.#sellerId
  }

  get entityId() {
    return this.#entityId
  }

  toJSON() {
    return {
      entityType: this.#entityType,
      entityId: this.#entityId,
      buyerId: this.#buyerId,
      ...(this.#isProfessionalSeller ? {contractId: this.#sellerId} : {privateSellerId: this.#sellerId})
    }
  }
}

export const factory = GetMessagingConversationIdUserRequest.create
